import React from 'react';
import { Modal } from 'antd';

function CacheFreshnessModal({ open, onOk, onCancel }: { open: boolean; onOk: () => void; onCancel: () => void }) {
  return (
    <Modal title="Cache Expiration" open={open} okText="Confirm" onOk={onOk} onCancel={onCancel}>
      <div className="text-danger">
        Decreasing the cache freshness interval will lead to an increased number of renders. Would you like to proceed
        with the change? You can read more details regarding our rendering process in{' '}
        <a href="https://docs.prerender.io/docs/what-you-pay-for" target="_blank" rel="noreferrer">
          this
        </a>{' '}
        article.
      </div>
    </Modal>
  );
}

export default CacheFreshnessModal;
